import React, { useState } from "react";
import { Card, Button } from "../../../../../common";
import { BankingDetail } from "./BankingDetail";

import { Link } from "react-router-dom";

export const AddBankingForm = ({ editBank, modalHandle, refetch, compRefetch, dataChanged, setDataChanged }) => {
  const [ibanNo, setIbanNo] = useState("");
  const [bankData, setBankData] = useState();

  const handleIbanNo = (e) => {
    e.preventDefault();
    setIbanNo(e.target.value);
  };

  const handleDetail = () => {
    if (ibanNo === "") {
      return;
    }

    var myHeaders = new Headers();
    myHeaders.append(
      "X-Api-Key",
      "sk_25640771e3a2d4ad9ace3404175e06c017addac4d68932ddf802d28fb79f286e"
    );

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    const getIBANNo = async (ibanNo) => {
      try {
        let res = await fetch(
          `https://swiftcodesapi.com/v1/ibans/${ibanNo}`,
          requestOptions
        );
        let data = await res.json();
        if (data?.success) {
          setBankData(data);
        }
      } catch (error) {
      }
    };

    getIBANNo(ibanNo);

  };
  return (
    <Card classes="rounded bg-white p-4 w-[34rem]">
      {!bankData && !editBank && (
        <div>
          <div className="w-fit tracking-subheading text-secondarytwo font-semibold text-f14 p-2 bg-breadcrumb rounded-lg px-4 -mt-4 mb-7">
            Select Bank
          </div>

          <div className="">
            <label
              htmlFor="IBAN"
              className="block mb-1 text-primary text-f14 font-semibold text-left"
            >
              IBAN
            </label>
            <input
              id="IBAN"
              value={ibanNo}
              onChange={handleIbanNo}
              placeholder="Enter"
              className="bg-white focus:border-banking focus:shadow-banking px-3 py-2 border border-input w-full rounded-lg relative"
            />
            <Button classes="p-2 text-link text-f14 absolute right-9 font-semibold" onClick={handleDetail}>
              Search Bank
            </Button>
            <div className="text-primaryText font-semibold text-f16 mt-5">
              Bank Not Found?{" "}
              <Link to="/dashboard/help" target="_blank" rel="noopener noreferrer" className="text-link">
                Contact Support
              </Link>
            </div>
          </div>
        </div>
      )}

      {bankData && (
        <BankingDetail
          onBankInfo={bankData}
          editBank={editBank}
          modalHandle={modalHandle}
          ibanNumber={ibanNo}
          compRefetch={compRefetch} refetch={refetch} dataChanged={dataChanged} setDataChanged={setDataChanged}
        />
      )}
      {editBank && (
        <BankingDetail
          onBankInfo={bankData}
          editBank={editBank}
          modalHandle={modalHandle}
          ibanNumber={ibanNo}
          compRefetch={compRefetch} refetch={refetch} dataChanged={dataChanged} setDataChanged={setDataChanged}
        />
      )}
    </Card>
  );
};
